import styled from 'styled-components'

export const StyledPartnerCardContainer = styled.div`
  width: 100%;
  margin: 22px auto 0 auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    max-width: 1920px;
  }
`
